// Dedicated Degree Apprenticeship marketing footer — shared by the landing
// page, feature writeups, Insights and Case Studies. Does not touch the
// shared GlobalFooter.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import CookieSettingsButton from '../../consent/CookieSettingsButton';
import './DegreeApprenticeshipLandingPage.css';

export default function DegreeApprenticeshipEditorialFooter() {
  const navigate = useNavigate();
  return (
    <footer className="degreeapprenticeship-editorial-footer">
      <div className="degreeapprenticeship-container">
        <div className="degreeapprenticeship-footer-grid">
          <div>
            <div className="degreeapprenticeship-footer-logo">IVORI<span className="degreeapprenticeship-footer-logo-suffix">Edu</span></div>
            <p className="degreeapprenticeship-footer-blurb">The AI for decision-makers. Tuned for the ones about to become one.</p>
            <p className="degreeapprenticeship-footer-contact-label">Questions? Email us:</p>
            <a href="mailto:support@ivoriai.com" className="degreeapprenticeship-footer-mail">support@ivoriai.com</a>
          </div>

          <div className="degreeapprenticeship-fcol">
            <h4>Company</h4>
            <a href="https://ivorilab.com" target="_blank" rel="noopener noreferrer">IVORI Lab</a>
            <button type="button" onClick={() => navigate('/method/degreeapprenticeship')}>IVORI Edu Method</button>
            <h4 style={{ marginTop: 36 }}>Products</h4>
            <a href="https://ivoriai.com" target="_blank" rel="noopener noreferrer">IVORI</a>
            <a href="https://ivoriai.com/" target="_blank" rel="noopener noreferrer">IVORI Edu</a>
          </div>

          <div className="degreeapprenticeship-fcol">
            <h4>Features</h4>
            <button type="button" onClick={() => navigate('/features/chat')}>Chat</button>
            <button type="button" onClick={() => navigate('/features/fluid')}>Fluid</button>
            <button type="button" onClick={() => navigate('/features/studio')}>Studio</button>
            <button type="button" onClick={() => navigate('/features/apps')}>Apps</button>
            <button type="button" onClick={() => navigate('/features/cases')}>Cases</button>
          </div>

          <div className="degreeapprenticeship-fcol">
            <h4>Exam Apps</h4>
            <a href="https://esat.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">ESAT</a>
            <a href="https://lnat.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">LNAT</a>
            <a href="https://tara.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">TARA</a>
            <a href="https://tmua.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">TMUA</a>
            <a href="https://ucat.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">UCAT</a>
          </div>

          <div className="degreeapprenticeship-fcol degreeapprenticeship-fcol-wide">
            <h4>Interview Apps</h4>
            <a href="https://oxbridge.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">Oxbridge</a>
            <a href="https://medicalschool.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">Medical School</a>
            <a href="https://degreeapprenticeship.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer" className="degreeapprenticeship-nowrap-link">Degree Apprenticeship</a>
            <h4 style={{ marginTop: 36 }}>Resources</h4>
            <button type="button" onClick={() => navigate('/insights')}>Degree Apprenticeship Insights</button>
          </div>
        </div>
      </div>

      <div className="degreeapprenticeship-footer-bottom-outer">
        <div className="degreeapprenticeship-container degreeapprenticeship-footer-bottom">
          <span>© {new Date().getFullYear()} IVORI Lab. all rights reserved.</span>
          <div className="degreeapprenticeship-footer-links">
            <button type="button" onClick={() => navigate('/privacy')}>Privacy</button>
            <button type="button" onClick={() => navigate('/terms-of-use')}>Terms</button>
            <button type="button" onClick={() => navigate('/safeguarding')}>Safeguarding</button>
            <button type="button" onClick={() => navigate('/cookies')}>Cookies</button>
            <CookieSettingsButton />
          </div>
        </div>
      </div>
    </footer>
  );
}
